import React from "react";
import JobSchedulesCalendar from "./JobSchedulesCalendar";

function JobSchedulesCalendarView({
    jobSchedules,
    selectedRows,
    onSelectedRowsChange,
    onRefresh,
    onEventClick,
    filterText,
}) {
    return (
        <JobSchedulesCalendar
            jobSchedules={jobSchedules}
            onRefresh={onRefresh}
            onEventClick={onEventClick}
            filterText={filterText}
        />
    );
}

export default JobSchedulesCalendarView;
